import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { enrichCheckinDocs } from '../utils/enrichCheckinDocs';

/**
 * Custom hook to fetch the latest 20 checkins with brewery, beer, event, and user information.
 * Returns enriched checkin view models for CheckinCard.
 */
function useCheckinsList() {
  const [checkins, setCheckins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchCheckins = async () => {
      try {
        if (!cancelled) {
          setLoading(true);
          setError(null);
        }

        const checkinsRef = collection(db, 'checkins');
        const checkinsQuery = query(checkinsRef, orderBy('date', 'desc'), limit(20));
        const checkinsSnapshot = await getDocs(checkinsQuery);

        if (cancelled) return;

        if (!checkinsSnapshot.empty) {
          const checkinsData = await enrichCheckinDocs(checkinsSnapshot.docs);

          if (!cancelled) {
            setCheckins(checkinsData);
          }
        } else if (!cancelled) {
          setCheckins([]);
        }
      } catch (err) {
        console.error('Error fetching checkins:', err);
        if (!cancelled) {
          setError(err.message);
          setCheckins([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchCheckins();

    return () => {
      cancelled = true;
    };
  }, []);

  return { checkins, loading, error };
}

export default useCheckinsList;
